import Axios from '@/api/http'

/**
 * 获取红点数据
 * */
export function openapiGetapprovalnum(query) {
  return Axios({
    method: 'post',
    url: '/openapi/getapprovalnum',
    data: query
  })
}

/**
 * 查应用权限列表(走用户权限)
 * */
export function openapiGetapproval(query) {
  return Axios({
    method: 'post',
    url: '/openapi/getapproval',
    data: query
  })
}

/**
 * 查应用权限列表（不走用户权限）
 * */
export function apiGetapproval(query) {
  return Axios({
    method: 'post',
    url: '/api/getapproval',
    data: query
  })
}

/**
 * 批量审批
 * */
export function batchupdateapprovalprocess(query) {
  return Axios({
    method: 'post',
    url: '/openapi/batchupdateapprovalprocess',
    data: query
  })
}

/**
 * 批量审批(全部数据)
 * */
export function batchupdateuserapprovingprocess(query) {
  return Axios({
    method: 'post',
    url: '/openapi/batchupdateuserapprovingprocess',
    data: query
  })
}

/**
 * 获取个人数据
 * */
export function getuserfielddatalist(query) {
  return Axios({
    method: 'post',
    url: '/api/getuserfielddatalist',
    data: query
  })
}

/**
 * 获取流程和告知相关的东西
 * */
export function getapprovaluser(query) {
  return Axios({
    method: 'post',
    url: '/openapi/getapprovaluser',
    data: query
  })
}

/**
 * 多表提交
 * */
export function addapprovalings(query) {
  return Axios({
    method: 'post',
    url: '/openapi/addapprovalings',
    data: query
  })
}
